import React, { useState } from 'react';
import { Shield, Lock, FileText, CheckCircle, Info } from 'lucide-react';

const ComplianceFooter: React.FC = () => {
  const [showCompliance, setShowCompliance] = useState(false);

  return (
    <div className="mt-8 pt-6 border-t border-neutral-200 bg-neutral-50 -mx-6 -mb-6 px-6 pb-6 rounded-b-xl">
      <div className="text-center">
        <h4 className="text-sm font-semibold text-neutral-700 mb-3 text-center">
          Compliance & Security Information
        </h4>
        
        <div className="mt-3 text-xs text-neutral-500">
          <p>All data is encrypted, securely stored, and processed in compliance with international standards.</p>
          <p className="mt-1">© 2000 - 2025 IFED Secure Data Room. All rights reserved.</p>
          
          <button
            type="button"
            className="flex items-center space-x-2 mt-3 mx-auto text-xs text-[#cba864] italic hover:underline focus:outline-none"
            onClick={() => setShowCompliance((v) => !v)}
          >
            <Info className="w-4 h-4" color="#cba864" />
            <span>Compliance Information</span>
          </button>
          
          {showCompliance && (
            <div className="mt-3 p-3 bg-neutral-50 border border-neutral-200 rounded text-xs text-neutral-700 max-w-lg mx-auto text-left shadow-sm">
              <strong>European Signature Compliance Statement (Available with Qualified Service Orders)</strong><br />
              <p className="mt-2 leading-relaxed">
                By default, all electronic signatures on our platform follow the IFED Standard, suitable for general-purpose use and internal documentation. This standard ensures efficiency and reliability within our ecosystem but may not meet jurisdiction-specific legal requirements for all use cases.
              </p>
              <p className="mt-2 leading-relaxed">
                For clients requiring full compliance with the EU eIDAS Regulation (EU) No 910/2014, including Simple (SES), Advanced (AdES), and Qualified (QES) Electronic Signatures, we offer an optional Qualified Signature Service. When ordered, this service includes:
              </p>
              <ul className="mt-2 ml-4 list-disc space-y-1">
                <li>Integration with certified Qualified Trust Service Providers (QTSPs)</li>
                <li>Use of certified signature creation devices</li>
                <li>Trusted timestamping, certificate validation, and comprehensive audit trails</li>
                <li>Full adherence to ETSI technical standards and GDPR data protection requirements</li>
              </ul>
              <p className="mt-2 leading-relaxed">
                This ensures the highest level of legal enforceability and cross-border recognition within the EU.
              </p>
              <p className="mt-2 leading-relaxed">
                Please note: Legal acceptance of electronic signatures may vary by jurisdiction and use case. We strongly recommend consulting legal counsel to determine the appropriate level of signature required for your specific needs.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ComplianceFooter; 